import axiosInstance from "../axiosInstanceSetup";
const BASE_URL = process.env.REACT_APP_API_URL;
const appService = {
 
  getDomainsAndSubDomains: async () => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}/parentdomain_domain_subdomain_list/`
      );
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
    getLoggedInUserDetails: async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/user/details`);
      return response.data;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  },
};

export default appService;
